$(document).ready(function() {

    window.hideLastColumnGridline = function() {
        $('#mw .sharable-dashboard .media-exposure__graph.column').each(function(index) {
            $(this).find('.highcharts-grid path:last').css('display', 'none');
        });
    };

});